(function () {
  function revealPanel(panel) {
    if (!panel || panel.classList.contains('is-animated')) return;
    panel.classList.add('is-animated');
  }

  function getSlickInstance($carousel) {
    if (!$carousel || !$carousel.length || !$carousel.hasClass('slick-initialized')) {
      return null;
    }

    try {
      return $carousel.slick('getSlick');
    } catch (error) {
      return null;
    }
  }

  function updateCarouselNav($sectionRoot, $carousel) {
    var $nav = $sectionRoot.find('.js-product-features-nav');
    var $prev = $sectionRoot.find('.js-product-features-prev');
    var $next = $sectionRoot.find('.js-product-features-next');
    var slick = getSlickInstance($carousel);

    if (!slick) {
      $nav.prop('hidden', true);
      $prev.prop('disabled', true);
      $next.prop('disabled', true);
      return;
    }

    var slideCount = slick.slideCount;
    var slidesToShow = slick.options.slidesToShow;
    var currentSlide = slick.currentSlide;
    var hideNav = slideCount <= slidesToShow;
    var atStart = currentSlide <= 0;
    var atEnd = currentSlide >= slideCount - Math.ceil(slidesToShow);

    $nav.prop('hidden', hideNav);
    $prev.prop('disabled', hideNav || atStart);
    $next.prop('disabled', hideNav || atEnd);
  }

  function initSlickCarousel($sectionRoot, $carousel, onReady) {
    if (!$carousel.length) {
      if (onReady) onReady();
      return;
    }

    var refreshNav = function () {
      updateCarouselNav($sectionRoot, $carousel);
    };

    if ($carousel.hasClass('slick-initialized')) {
      try {
        $carousel.slick('setPosition');
      } catch (error) {}

      refreshNav();
      if (onReady) onReady();
      return;
    }

    $carousel
      .off('afterChange.productFeatures reInit.productFeatures breakpoint.productFeatures')
      .on('afterChange.productFeatures reInit.productFeatures breakpoint.productFeatures', refreshNav);

    $carousel.slick({
      slide: '.js-product-features-slide',
      arrows: false,
      infinite: false,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: false,
      edgeFriction: 1,
      mobileFirst: true,
      slidesToShow: 1.25,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 2.5 } },
        { breakpoint: 1023, settings: { slidesToShow: 4 } },
      ],
    });

    try {
      $carousel.slick('setPosition');
    } catch (error) {}

    refreshNav();
    if (onReady) onReady();
  }

  function ProductFeatures(root) {
    this.root = root;
    this.activeCarousel = null;
    this.carouselNavInteraction = false;
    this.tablist = root.querySelector('[role="tablist"]');
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('.product-features__panel'));
    this.activeIndex = 0;

    this.bindCarouselNav();

    if (this.tabs.length > 0) {
      this.activeIndex = this.tabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });

      if (this.activeIndex < 0) {
        this.activeIndex = 0;
      }

      this.bindTabs();
      this.activateTab(this.activeIndex, { initial: true });
      return;
    }

    if (this.panels.length > 0) {
      this.initCarousel(this.panels[0]);
      revealPanel(this.panels[0]);
    }
  }

  ProductFeatures.prototype.getSectionTitle = function () {
    var headingEl = this.root.querySelector('.product-features__heading');
    return headingEl ? headingEl.textContent.trim() : '';
  };

  ProductFeatures.prototype.getActiveTabLabel = function () {
    if (!this.tabs.length || !this.tabs[this.activeIndex]) return '';
    return this.tabs[this.activeIndex].textContent.trim();
  };

  ProductFeatures.prototype.bindCarouselNav = function () {
    var self = this;
    var $sectionRoot = window.jQuery(this.root);

    $sectionRoot.find('.js-product-features-prev').on('click', function () {
      if (!getSlickInstance(self.activeCarousel)) return;
      self.carouselNavInteraction = true;
      self.activeCarousel.slick('slickPrev');
    });

    $sectionRoot.find('.js-product-features-next').on('click', function () {
      if (!getSlickInstance(self.activeCarousel)) return;
      self.carouselNavInteraction = true;
      self.activeCarousel.slick('slickNext');
    });
  };

  ProductFeatures.prototype.bindCarouselTracking = function ($carousel) {
    var self = this;

    if (!$carousel.length || $carousel.data('featuresCarouselTrackInit')) return;

    $carousel.data('featuresCarouselTrackInit', true);

    var hasInitialized = false;

    $carousel.on('afterChange.productFeaturesTrack', function (event, slick, currentSlide) {
      if (!hasInitialized) {
        hasInitialized = true;
        return;
      }

      if (self.carouselNavInteraction) {
        self.carouselNavInteraction = false;
        return;
      }

      if (typeof pushSectionTrackingEvent !== 'function') return;

      var activeTabLabel = self.getActiveTabLabel();

      pushSectionTrackingEvent('Feature Carousel Swipe', self.getSectionTitle(), {
        headline: activeTabLabel,
        subtitle: 'Slide ' + ((currentSlide || 0) + 1),
        linkPath: window.location.pathname,
      });
    });
  };

  ProductFeatures.prototype.bindTabs = function () {
    var self = this;

    if (!this.tabs.length) return;

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        self.activateTab(index);
      });
    });

    if (!this.tablist) return;

    this.tablist.addEventListener('keydown', function (event) {
      var currentIndex = self.tabs.indexOf(document.activeElement);
      if (currentIndex < 0) return;

      var nextIndex = currentIndex;
      var key = event.key;

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = currentIndex === 0 ? self.tabs.length - 1 : currentIndex - 1;
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = currentIndex === self.tabs.length - 1 ? 0 : currentIndex + 1;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = self.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      self.activateTab(nextIndex, { focus: true });
    });
  };

  ProductFeatures.prototype.activateTab = function (index, options) {
    options = options || {};

    if (index < 0 || index >= this.tabs.length) return;
    if (index === this.activeIndex && !options.initial) return;

    this.activeIndex = index;

    this.tabs.forEach(function (tab, tabIndex) {
      var isSelected = tabIndex === index;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    this.panels.forEach(function (panel, panelIndex) {
      panel.toggleAttribute('hidden', panelIndex !== index);
    });

    var activePanel = this.panels[index];
    if (!activePanel) return;

    this.initCarousel(activePanel);

    if (options.focus) {
      if (typeof pushSectionTrackingEvent === 'function') {
        pushSectionTrackingEvent('Feature Tab', this.getSectionTitle(), {
          subtitle: this.tabs[index].textContent.trim(),
          linkPath: window.location.pathname,
        });
      }

      this.tabs[index].focus();
    }
  };

  ProductFeatures.prototype.initCarousel = function (panel) {
    if (!window.jQuery || !window.jQuery.fn.slick) return;

    var self = this;
    var $sectionRoot = window.jQuery(this.root);
    var $carousel = window.jQuery(panel).find('.js-product-features-carousel');

    this.activeCarousel = $carousel;

    initSlickCarousel($sectionRoot, $carousel, function () {
      if (self.panels[self.activeIndex] !== panel) return;
      revealPanel(panel);
    });

    this.bindCarouselTracking($carousel);
  };

  function initProductFeatures(root) {
    if (!root || root.dataset.productFeaturesInit === 'true') return;
    root.dataset.productFeaturesInit = 'true';
    new ProductFeatures(root);
  }

  function initWhenReady(scope) {
    if (!window.jQuery || !window.jQuery.fn.slick) {
      window.setTimeout(function () {
        initWhenReady(scope);
      }, 50);
      return;
    }

    (scope || document).querySelectorAll('.js-product-features').forEach(initProductFeatures);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWhenReady();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initWhenReady(event.target);
  });
})();
